/**
 * Social Media Configuration
 *
 * Update these URLs with your actual social media profiles
 */

export const socialMediaLinks = {
  facebook: {
    url: "https://www.facebook.com/aaaprinterz",
    label: "Follow us on Facebook",
    enabled: true,
  },
  instagram: {
    url: "https://www.instagram.com/aaaprinterz",
    label: "Follow us on Instagram",
    enabled: true,
  },
  twitter: {
    url: "https://twitter.com/aaaprinterz",
    label: "Follow us on Twitter",
    enabled: true,
  },
  youtube: {
    url: "https://www.youtube.com/@aaaprinterz",
    label: "Subscribe on YouTube",
    enabled: true,
  },
  tiktok: {
    url: "https://www.tiktok.com/@aaaprinterz",
    label: "Follow us on TikTok",
    enabled: false, // Set to true to show TikTok icon
  },
  whatsapp: {
    url: "https://wa.me/97336618183", // AAA Printers WhatsApp Business
    label: "Chat on WhatsApp",
    enabled: true,
  },
};

/**
 * Contact Information
 */
export const contactInfo = {
  email: "info@aaaprinterz.com",
  phone: "+973 3661 8183",
  address: "Manama, Kingdom of Bahrain",
};

/**
 * Business Hours
 */
export const businessHours = {
  weekdays: "Sunday - Thursday: 9:00 AM - 6:00 PM",
  weekend: "Saturday: 10:00 AM - 4:00 PM",
  closed: "Friday: Closed",
};
